import React from 'react';

const config = {
    _company: 'yljz',
    baseName: 'Finlaris',
    footer: <React.Fragment>
        <p style={{ color: '#999', width: '100%' }}>© 2012-{(new Date()).getFullYear()} FINLARIS PTE. LTD. All rights reserved.</p>
    </React.Fragment>,
    logoImg: <img style={{ height: 34, width: 120 }} src={require('image/logo-fin-auth.png')} alt="" />, // NotFound 页面
    logoLink: <a href="/product/finauth" className="logo">
        <img style={{ height: 34, width: 120 }} src={require('image/logo-fin-auth.png')} />
    </a>,
    showNavMenu: false,
    showConcatUs: false,
    documentLink: 'https://global.yljz.com/document/finauth-guide-docs/PRO-App-Authentication',
};

export default Object.freeze(config);



// WEBPACK FOOTER //
// ./src/envcompany/envyljz.jsx